export var bmVersion = function bmVersion() {
  return {
    'bm:version': 3
  };
};